import { useParams } from '../libs/react-router';

/**
 * RenderByRouteParam component
 *
 * This component gets the route parameters and renders the provided component
 * with those parameters passed as props. It acts as a wrapper that automatically
 * injects route parameters into the child component.
 *
 * @param {Object} props - Component props
 * @param {Function} props.component - The component to render with route parameters
 * @returns {React.ReactElement} The rendered component with route parameters
 */
const RenderByRouteParam = ({ component }: { component: (_params: any) => React.ReactElement }) => {
  const params = useParams();

  return component(params);
};

export default RenderByRouteParam;
